import { STRAPI_URL, strapiEndpoints } from "config/endpoint";
import { QueryOptions } from "functions/buildQueryParams";
import { HTTP } from "functions/http";

export const GetTermsConditions = (query: QueryOptions) => {
  return HTTP({
    Method: "GET",
    baseURL: STRAPI_URL,
    Url: strapiEndpoints.TERMS_CONDITIONS(query),
    isStrapi: true,
    isCancellable: false,
  });
};
